import { ResponseType } from 'axios';
import { SOLICITOR_NOMINEE } from 'src/constants';
import { ENDPOINT, HTTP_METHOD } from 'src/constants/api';
import { IOtherDetail } from 'src/interfaces/accounts/account';
import { ICompanyInfo, IContactPerson, ICorporateLoanLending } from 'src/interfaces/accounts/company';
import { DTO } from './base.dto';
import { DeleteFileDTO } from './onboarding.dto';

export class CompanyInfoDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: ICompanyInfo;
	public url: string = ENDPOINT.CORPORATE_FUNDER_COMPANY_DETAIL;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: ICompanyInfo) {
		super();
		this.body = body;
	}
}

export class CorporateFunderOnboardingProgressDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CORPORATE_FUNDER_ONBOARDING_PROGRESS;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor() {
		super();
	}
}

export interface ICorporateaFunderFSA {
	address?: string;
	ciNo?: string;
	companyName?: string;
	country?: string;
	generateDate?: Date;
	onboardingStatus?: number;
	solicitorNominee?: SOLICITOR_NOMINEE;
	hkId?: string;
	hkIdPart1?: string;
	hkIdPart2?: string;
}

export interface CreateFunderContactPersonResponse {
	personId?: string;
	residentialAddressId?: string;
	mailingAddressId?: string;
	referenceCurrency?: string
}
export class CorporateContactPersonDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: IContactPerson;
	public url: string = ENDPOINT.CORPORATE_FUNDER_CONTRACT_PERSON;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IContactPerson) {
		super();
		this.body = body;
	}
}


export class CorporateLoanLendingDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: ICorporateLoanLending;
	public url: string = ENDPOINT.CORPORATE_FUNDER_LOAN_CRITERIA;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: ICorporateLoanLending) {
		super();
		this.body = body;
	}
}

export class CompanyDeleteFileDTO extends DeleteFileDTO {
	public url: string = ENDPOINT.CORPORATE_FUNDER_FUNDER_FILE;
	constructor(param: { documentId: string }) {
		super(param);
		this.param = param;
	}
}


export class CorporateSaveDraftDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CORPORATE_FUNDER_SAVE_DRAFT;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(url = ENDPOINT.CORPORATE_FUNDER_SAVE_DRAFT) {
		super();
		if (url) {
			this.url = url;
		}
	}
}


export class CorporateSubmitDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CORPORATE_FUNDER_SUBMIT;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(url = ENDPOINT.CORPORATE_FUNDER_SUBMIT) {
		super();
		if (url) {
			this.url = url;
		}
	}
}

export class CorporateFunderOnboardingFsaDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CORPORATE_FUNDER_FSA;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor() {
		super();
	}
}

export class CorporateFunderSignFsaDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CORPORATE_SIGN_FSA;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor() {
		super();
	}
}


export class CorporateBorrowerOnboardingProgressDTO extends CorporateFunderOnboardingProgressDTO {
	public url: string = ENDPOINT.CORPORATE_BORROWER_ONBOARDING_PROGRESS;
}

export class CorporateBorrowerCompanyInfoDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: ICompanyInfo;
	public url: string = ENDPOINT.CORPORATE_BORROWER_SAVE_COMPANY_DETAIL;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: ICompanyInfo) {
		super();
		this.body = body;
	}
}

export class CorporateBorrowerContactPersonDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: IContactPerson;
	public url: string = ENDPOINT.CORPORATE_BORROWER_SAVE_CONTACT_PERSON;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IContactPerson) {
		super();
		this.body = body;

	}
}

export class CorporateBorrowerOtherDetailDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: IOtherDetail;
	public url: string = ENDPOINT.CORPORATE_BORROWER_SAVE_OTHER_DETAILS;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IOtherDetail) {
		super();
		this.body = body;
	}
}

export class CorporateBorrowerSaveAsDraftDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CORPORATE_BORROWER_SAVE_SAFE_DRAFT;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor() {
		super();
	}
}

export class CorporateBorrowerSubmitDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CORPORATE_BORROWER_SAVE_SUBMIT;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor() {
		super();
	}
}


